var _rect, _rect2, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBcExplainerHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1090,
    height: 200,
    viewBox: "0 0 1090 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1090,
    height: 200,
    fill: "#FF3057"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1090,
    height: 200,
    fill: "url(#pattern0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1199.67 0L972.703 1.90263e-05C876.181 3.99482e-05 919.619 200 782.752 200H1199.67V0Z",
    fill: "#F8F7FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.67 0L972.703 1.90263e-05C876.181 3.99482e-05 919.619 200 782.752 200H1199.67V0Z",
    fill: "url(#pattern1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 0.0216667,
    height: 0.13
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_39_3147",
    transform: "scale(0.000833333 0.005)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 0.0592705,
    height: 0.13
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_39_3147",
    transform: "scale(0.00227964 0.005)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_39_3147",
    width: 26,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAQAAAADQ4RFAAABEklEQVR4Ac2Sr47DMAyHzUdGhkZKQopCSoZG8nR7iPHRgUhRpXZaHuz0ycr5/uhHTydrU9PPnj3ns17ux3V+X3v5Gpw1sfuxl9+Id5rYOq/z95f70suWW4Lw9LOkJXtf/bduh8fpeSZ6aamlLUO2zKlOg/jIxgMlvTzP60xSnUh8XZy0xBsIGWRu2RzRhVH4eBpDEnWqUxAyP4u8yxiMM9+CRJGDMRhnSaLI2wOjkyI2llwn2r8uACYfRaQNQhb/1mJHEb6jOHnEXo1bon3cxuN0OwwX8CJukGnINoC335ctj8AFJ+xuxL74kH8orNZSq2xaS62yaS21yqa11Cr/d2G1llpl01pqlU1rqVU2raVW+QN0FoE7TK1N4wAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcExplainerHeader);
export default __webpack_public_path__ + "static/media/bc-explainer-header.5734a8307397da1f91594f04e12eb6a3.svg";
export { ForwardRef as ReactComponent };